const Settings = () => import("../appraisal/views/Settings.vue");
const FinalGrade = () => import("../appraisal/views/FinalGrade.vue");
const GeneralSettings = () => import("../appraisal/views/GeneralSettings.vue");
const ScoreCard = () => import("../appraisal/views/ScoreCard.vue");
const Appraisers = () => import("../appraisal/views/Appraisers.vue");
const ScoreCardTemplate = () =>
  import("../appraisal/views/ScoreCardTemplate.vue");
const EditAppraisal = () => import("../appraisal/views/EditAppraisal.vue");
const AppraisalDetailsView = () =>
  import("../appraisal/views/AppraisalDetailsView.vue");
const AssignAppraisal = () =>
  import("../appraisal/components/AssignAppraisal.vue");
const ManageAppraisal = () =>
  import("../appraisal/components/ManageAppraisal.vue");
const AllAppraisalTable = () =>
  import("../appraisal/components/AllAppraisalTable.vue");
const CreateAppraisalSettings = () =>
  import("../appraisal/views/CreateAppraisalSettings.vue");
const TemplateForm = () => import("../appraisal/views/TemplateForm.vue");
const AllAppraisals = () => import("../appraisal/views/AllAppraisals.vue");
const ViewAnAppraisal = () => import("../appraisal/views/ViewAnAppraisal.vue");
const AnAppraisalDetailsView = () =>
  import("../appraisal/views/AnAppraisalDetailsView.vue");
const AppraiseTemplate = () =>
  import("../appraisal/views/AppraiseTemplate.vue");
const MyAppraisal = () => import("../appraisal/views/MyAppraisal.vue");
const Appraise = () => import("../appraisal/views/Appraise.vue");

export const tabLinks = [
  {
    label: "All Appraisal",
    url: "/admin/hrm/appraisal/all",
  },
  {
    label: "My Appraisal",
    url: "/admin/hrm/appraisal/my-appraisal",
  },
  {
    label: "Appraise",
    url: "/admin/hrm/appraisal/appraise",
  },
];
export const settings = "/admin/hrm/appraisal/settings";
export default [
  {
    path: "all",
    component: AllAppraisals,
  },
  {
    path: "all/appraisal-records",
    component: ViewAnAppraisal,
  },
  {
    path: "all/appraisal-records/:id",
    component: AnAppraisalDetailsView,
  },
  {
    path: "all/appraise-employee/:id",
    component: AppraiseTemplate,
  },
  {
    path: "all/self-appraise/:id",
    component: AppraiseTemplate,
  },
  {
    path: "my-appraisal",
    component: MyAppraisal,
  },
  {
    path: "my-appraisal/:id",
    component: AnAppraisalDetailsView,
  },
  {
    path: "my-appraisal/appraise/:id",
    component: AppraiseTemplate,
  },
  {
    path: "appraise",
    component: Appraise,
  },
  {
    path: "appraise/view-appraisal/:id",
    component: AnAppraisalDetailsView,
  },
  {
    path: "appraise/:id",
    component: AppraiseTemplate,
  },

  {
    path: "settings",
    component: Settings,
  },
  {
    path: "assign-appraisal/:id",
    component: AssignAppraisal,
  },
  {
    path: "manage-appraisal/:id",
    component: ManageAppraisal,
  },
  {
    path: "edit/:id",
    component: EditAppraisal,
  },
  {
    path: "details/:id",
    component: AppraisalDetailsView,
  },
  {
    path: "allappraisaltable",
    component: AllAppraisalTable,
  },
  {
    path: "create",
    component: CreateAppraisalSettings,
  },
  {
    path: "settings/final-grade",
    component: FinalGrade,
  },
  {
    path: "settings/general",
    component: GeneralSettings,
  },
  {
    path: "settings/scorecard",
    component: ScoreCard,
  },
  {
    path: "settings/create-scorecard",
    component: TemplateForm,
  },
  {
    path: "settings/scorecard-template-editor",
    component: ScoreCardTemplate,
  },
  {
    path: "settings/appraisers",
    component: Appraisers,
  },
];
